import React, { useState, Suspense } from 'react'
import { connect, useDispatch } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Input, Table, Badge, Form, Spin, Space } from 'antd'
import { createStructuredSelector } from 'reselect'
import { selectRoles, selectedRolesData } from 'redux/roles/selectors'
import { selectUser } from 'redux/user/selectors'
import RolesAction from 'redux/roles/actions'
import RemoveModal from '../RemoveModal'
import RoleForm from '../RoleForm'


const { Search } = Input

const mapStateToProps = () =>
  createStructuredSelector({
    roles: selectRoles,
    selectedRoles: selectedRolesData,
    selectedUser: selectUser,
  })

const ViewStaff = ({ selectedRoles, selectedUser, roles, intl: { formatMessage } }) => {

  console.log("selectedRoles", selectedRoles)
  console.log("roles", roles)
  console.log("selectedUser", selectedUser)


  const [page, setPage] = useState(1)
  const dispatch = useDispatch()

  const onSearch = value => {
    dispatch({
      type: RolesAction.SET_STATE,
      payload: { searchroles: value },
    })
  }

  const showCreate = () => {
    dispatch({
      type: RolesAction.SHOW_CREATE,
    })
  }

  const hideAdd = () => {
    dispatch({
      type: RolesAction.HIDE_CREATE,
    })
  }

  const onSubmitRole = values => {
    dispatch({
      type: RolesAction.CREATE,
      payload: values,
    })
  }

  const showDelete = staffrecord => {
    dispatch({
      type: RolesAction.SHOW_DELETE,
      payload: {
        staffInfo: staffrecord,
      },
    })
  }

  const hideDelete = () => {
    dispatch({
      type: RolesAction.HIDE_DELETE,
    })
  }

  const removeUser = () => {
    dispatch({
      type: RolesAction.REMOVE,
      payload: {
        _id: roles?.selectedData?.id,
      },
    })
  }

  const locale = {
    emptyText: formatMessage({ id: 'text.custommessage.RolesData' }),
  }

  const columns = [
    {
      title: formatMessage({ id: 'text.serialNo' }),
      key: 's_no',
      render: (text, record, index) => `${(page - 1) * 10 + index + 1}.`,
    },
    {
      title: formatMessage({ id: 'text.name' }),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: formatMessage({ id: 'text.status' }),
      dataIndex: 'status',
      key: 'status',
      render: text => (
        <>
          {text === '1' && (
            <>
              <Badge color="green" text={formatMessage({ id: 'text.active' })} />
            </>
          )}
          {text === '0' && (
            <>
              <Badge color="red" text={formatMessage({ id: 'text.inactive' })} />
            </>
          )}
        </>
      ),
    },
    {
      title: formatMessage({ id: 'text.action' }),
      key: 'action',
      hidden: selectedUser?.userRole !== 'Super Admin',
      render: (record, text) => (
        <Space size="middle">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => showDelete(text)}
            hidden={selectedUser?.userRole !== 'Super Admin'}
          >
            <i className="fe fe-trash mr-1" aria-hidden />
          </button>
        </Space>
      ),
    },
  ]

  return (
    <div className="mb-4">
      <div className="row">
        <div className="col-md-4">
          <Form.Item>
            <Search
              style={{ width: '100%' }}
              placeholder={formatMessage({ id: 'form.user.placeholder.searchRole' })}
              size="large"
              onChange={e => onSearch(e.target.value)}
              allowClear
            />
          </Form.Item>
        </div>
        <div className="col-md-8 text-right">
          <button
            type="button"
            className="btn theme-btn-style"
            onClick={showCreate}
            style={{ float: 'right', marginTop: '2.5px' }}
            hidden={selectedUser?.userRole !== 'Super Admin'}
          >
            <i className="fe fe-plus mr-1" aria-hidden="true" />
            {formatMessage({ id: 'action.createRole' })}
          </button>
        </div>
      </div>
      <div className="kit__utils__table">
        <Suspense fallback={<Spin />}>
          {selectedRoles?.length >= 0 ? (
            <Table
              dataSource={selectedRoles}
              columns={columns}
              locale={locale}
              rowKey="_id"
              pagination={{
                onChange(current) {
                  setPage(current)
                },
              }}
            />
          ) : (
            <Table
              columns={columns}
              locale={locale}
              loading={{
                indicator: (
                  <div>
                    <Spin />
                  </div>
                ),
              }}
            />
          )}
        </Suspense>
      </div>
      <RemoveModal
        visible={roles?.displayRemoveModal}
        title={`Remove Roles - ${roles?.selectedData?.name}`}
        description={formatMessage({ id: 'text.removeRole.description' })}
        onSubmit={removeUser}
        onCancel={hideDelete}
        loading={roles?.removing}
      />
      <RoleForm
        visible={roles?.displayAddModal}
        onSubmit={onSubmitRole}
        onCancel={hideAdd}
        loading={roles?.adding}
      />
    </div>
  )
}

export default connect(mapStateToProps)(injectIntl(ViewStaff))
